import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';

import VMScratchBlocks from '../../lib/blocks';

class CodeLibraryBlockPreview extends React.Component {
    componentDidMount () {
        this.ScratchBlocks = VMScratchBlocks(this.props.vm, false);
        this.ScratchBlocks.ScratchMsgs.setLocale(this.props.locale);
        this.workspace = this.ScratchBlocks.inject(this.blockPreview, {
            readOnly: true,
            collapse: false,
            comments: false,
            disable: false,
            sounds: false,
            trashcan: false,
            scrollbars: true,
            media: this.props.blocksMediaPath,
            zoom: {
                controls: true,
                wheel: true,
                startScale: 0.78
            },
            move: {
                drag: true,
                wheel: true,
                scrollbars: true
            }
        });
        this.renderPreview();
    }

    componentDidUpdate (prevProps) {
        if (prevProps.xml !== this.props.xml || prevProps.locale !== this.props.locale) {
            this.ScratchBlocks.ScratchMsgs.setLocale(this.props.locale);
            this.renderPreview();
        }
    }

    componentWillUnmount () {
        if (this.workspace) {
            this.workspace.dispose();
        }
    }

    renderPreview () {
        if (!this.workspace || !this.ScratchBlocks) return;
        this.workspace.clear();
        const dom = this.ScratchBlocks.Xml.textToDom(this.props.xml);
        this.ScratchBlocks.Xml.domToWorkspace(dom, this.workspace);
        setTimeout(() => {
            if (typeof this.workspace.zoomToFit === 'function') {
                this.workspace.zoomToFit();
            }
            this.workspace.setScale(0.85);
            this.workspace.scrollX = 24;
            this.workspace.scrollY = 24;
            this.workspace.resize();
        }, 0);
    }

    setBlockPreviewRef = node => {
        this.blockPreview = node;
    };

    render () {
        return (
            <div
                className={this.props.className}
                ref={this.setBlockPreviewRef}
            />
        );
    }
}

CodeLibraryBlockPreview.propTypes = {
    blocksMediaPath: PropTypes.string.isRequired,
    className: PropTypes.string,
    locale: PropTypes.string,
    vm: PropTypes.instanceOf(VM).isRequired,
    xml: PropTypes.string.isRequired
};

CodeLibraryBlockPreview.defaultProps = {
    className: '',
    locale: 'da'
};

export default CodeLibraryBlockPreview;
